const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20neon%20city%20skyline%20and%20spaceships%2C%20warm%20amber%20and%20deep%20crimson%20color%20palette%2C%20film%20grain%20texture%2C%20dramatic%20cinematic%20lighting%2C%20vintage%20sci-fi%20aesthetic%2C%20atmospheric%20depth%2C%20rich%20contrast%2C%20movie%20poster%20quality&width=1200&height=600&seq=carousel-66-01&orientation=landscape',
    tag: '科幻盛宴',
    title: '2026年度科幻大片盘点',
    desc: '从太空歌剧到赛博朋克，今年不容错过的十部科幻巨制',
    count: '12部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20scene%20with%20dramatic%20car%20chase%20in%20rainy%20night%20city%2C%20warm%20golden%20street%20lights%20reflecting%20on%20wet%20asphalt%2C%20film%20noir%20aesthetic%2C%20rich%20amber%20and%20dark%20tones%2C%20dramatic%20cinematography%2C%20intense%20atmosphere&width=1200&height=600&seq=carousel-66-02&orientation=landscape',
    tag: '动作专场',
    title: '肾上腺素爆表！硬核动作片合集',
    desc: '拳拳到肉的真实打斗，让你心跳加速的动作经典',
    count: '18部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20cinematic%20scene%20with%20couple%20walking%20through%20golden%20sunset%20city%20streets%2C%20warm%20soft%20lighting%2C%20film%20grain%20texture%2C%20vintage%20romantic%20movie%20aesthetic%2C%20dreamy%20atmosphere%2C%20rich%20golden%20amber%20tones%2C%20nostalgic%20vibe&width=1200&height=600&seq=carousel-66-03&orientation=landscape',
    tag: '轻松一刻',
    title: '治愈系喜剧片单：笑到停不下来',
    desc: '压力大的时候，这些电影就是最好的解药',
    count: '15部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20martial%20arts%20cinematic%20scene%20with%20ancient%20temple%20in%20misty%20mountains%2C%20warm%20golden%20sunlight%20through%20bamboo%20forest%2C%20film%20grain%20texture%2C%20wuxia%20movie%20aesthetic%2C%20atmospheric%20depth%2C%20rich%20amber%20and%20jade%20tones%2C%20poetic%20composition&width=1200&height=600&seq=carousel-66-04&orientation=landscape',
    tag: '经典重温',
    title: '百看不厌：华语电影经典回顾',
    desc: '那些年感动过我们的华语佳作，值得反复品味',
    count: '20部精选',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            专题聚焦
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精心策划的电影专题，发现更多观影惊喜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group relative rounded-2xl overflow-hidden cursor-pointer bg-background-200"
            >
              <div className="aspect-[16/9]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent rounded-2xl"></div>

              <div className="absolute bottom-0 left-0 w-full p-5 md:p-7">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-background-50/80 whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <h3 className="font-heading text-lg md:text-xl text-background-50 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 leading-relaxed max-w-[400px]">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}